/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystabSb } from '../../models/systab-sb';

export interface GetTypes$Params {
  orid: number;
  scid: number;
}

export function getTypes(http: HttpClient, rootUrl: string, params: GetTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SystabSb>>> {
  const rb = new RequestBuilder(rootUrl, getTypes.PATH, 'get');
  if (params) {
    rb.path('orid', params.orid, {});
    rb.path('scid', params.scid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SystabSb>>;
    })
  );
}

getTypes.PATH = '/api/MasterDataSource/{orid}/{scid}';
